/* global $ */
import { Slider } from '.';

class ImageGallery {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.$wrapper = $('.wrapper');
    this.$images = $('.js-gallery');

    this.currentSlide = 0;
    this.$gallery = null;
    this.gallerySlider = null;

    this.init();
  }

  init() {
    this.$body.removeClass('js-gallery-active js-gallery-enabled'); 
    const isGalleryDisabled = this.$body.find('.js-gallery-disabled').length > 0;

    if (isGalleryDisabled) {
      return;
    }

    if (this.$images.length > 1) {
      this.$body.addClass('js-gallery-enabled'); 
      this.$images.click(evt => this.createGallery(evt));
      $('.js-open-gallery').click(() => this.createGallery());
      this.setImageIndex();
    }
  }

  setImageIndex() {
    this.$images.each((index, el) => {
      $(el).attr('data-index', index);
    });
  }

  createGallery(evt) {
    if (!this.$gallery) {
      const titleText = $('.project-title').text();
      const titleTextP = `<p class="gallery-title">${titleText}</p>`;
      const galleryClose =
        '<div class="js-gallery-close"><svg class="close-icon"><use xlink:href="#icon-close"></use></svg>Close</div>';
      const galleryImageWrapper = '<div class="js-gallery-slider"></div>';
      const galleryContainer = `<section class="js-image-gallery image-gallery">${galleryClose}<div class="image-gallery__container">${titleTextP}${galleryImageWrapper}</div></section>`;

      this.$wrapper.append(galleryContainer);
      this.$gallery = $('.js-image-gallery');
      this.currentSlide = evt ? $(evt.currentTarget).data('index') : 0;

      $('.js-gallery-close').click(() => this.deinit());
      this.cloneImages();
      setTimeout(() => this.initializeSlider(), 50);
    }
  }

  cloneImages() {
    const $slideArr = this.$images.map((i, img) => {
      const imgSrc = $(img)
        .find('img')
        .attr('src');
      const $caption = $(img)
        .find('.gallery-caption')
        .clone();

      return $(document.createElement('div')).append(
        $(document.createElement('div'))
          .addClass('gallery-item-wrapper')
          .prepend(
            $('<figure>')
              .addClass('gallery-figure')
              .css('background-image', `url(${imgSrc})`)
              .prepend(
                $('<img>')
                  .addClass('gallery-img')
                  .attr('src', `${imgSrc}`),
              ),
          )
          .prepend($caption),
      );
    });

    $slideArr.map((i, slide) => slide.appendTo('.js-gallery-slider'));
  }

  initializeSlider() {
    this.$body.addClass('js-gallery-active');
    this.gallerySlider = new Slider('.js-gallery-slider', this.currentSlide);

    this.$window.on('resize.gallery', () => {
      if (this.gallerySlider.isInitialized()) {
        this.gallerySlider.resize();
      } else {
        this.deinit();
      }
    });
    this.$window.on('keydown.gallery', evt => this.escGallery(evt));
  }

  deinit() {
    if (this.gallerySlider) {
      this.gallerySlider.deinit();
    }

    if (this.$gallery) {
      this.$gallery.remove();
    }

    this.$gallery = null;
    this.$body.removeClass('js-gallery-active');
    this.$window.off('keydown.gallery');
    this.$window.off('resize.gallery');
  }

  escGallery(evt) {
    if (evt.which === 27) {
      evt.preventDefault();
      this.deinit();
    }
  }
}

export default ImageGallery;
